export enum WidgetType{
   TEXT = "TEXT", CHECKBOX = "CHECKBOX", EQUIPMENT = "EQUIPMENT", CHEMICAL_LOT = "CHEMICAL_LOT"
}

export enum WidgetTypeLabel{
    TEXT = "Text", CHECKBOX = "Checkbox", EQUIPMENT = "Equipment", CHEMICAL_LOT = "Chemical Lot"
}